// extracted by mini-css-extract-plugin
export default {"Container":"franchise_Container__PwH9+","Body":"franchise_Body__Kkwmv","Description":"franchise_Description__1ABWg","LocationBackground":"franchise_LocationBackground__dPoq5"};